import {
  BRAND_LABEL,
  BRAND_LABEL_WITH_LOCATION,
} from '@moonpig/web-core-brand/config'

export const formatMetaTitleForStore = ({
  title,
  region,
}: {
  title: string
  region: string
}) => {
  const brandLabel = BRAND_LABEL_WITH_LOCATION[region] ?? BRAND_LABEL
  return `${title} | ${brandLabel}`
}
